module.exports = __webpack_public_path__ + "static/media/foodo1.77af7a33.png";